import Routes from "./routes";

function App() {
  /*const backgroundArray = [back1, back2, back3, back4];
  const randomIndex = Math.floor(Math.random() * backgroundArray.length);
  const selectedImage = backgroundArray[randomIndex];
  const style = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${back1})`,
    minHeight: "100vh",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };*/

  return (
    <div className="app-container">
      <Routes />
    </div>
    /*
    <div style={style}>
      <Routes  />
    </div>*/
  );
}

export default App;
